// --- React
import React from 'react';
import PropTypes from 'prop-types';
// --- External UI Libraries
import { Tag } from 'antd';

/**
 * Status configuration mapping
 * Maps status values to display colors and labels
 */
const STATUS_CONFIG = {
    active: { color: 'green', label: 'Active' },
    inactive: { color: 'default', label: 'Inactive' },
    pending: { color: 'orange', label: 'Pending' },
    error: { color: 'red', label: 'Error' },
    success: { color: 'green', label: 'Success' },
    failed: { color: 'red', label: 'Failed' },
    processing: { color: 'blue', label: 'Processing' },
    // Load status mappings
    loaded: { color: 'green', label: 'Loaded' },
    'not loaded': { color: 'default', label: 'Not Loaded' },
    loading: { color: 'blue', label: 'Loading' },
};

/**
 * StatusBadge Component
 *
 * Displays a color-coded badge for status values.
 * Automatically maps common status strings to appropriate colors.
 *
 * @param {string} status - The status value to display
 * @param {string} className - Optional additional CSS class
 */
export const StatusBadge = ({ status, className = '' }) => {
    if (!status) return null;

    const normalizedStatus = String(status).toLowerCase().trim();
    const config = STATUS_CONFIG[normalizedStatus] || {
        color: 'default',
        label: status,
    };

    return (
        <Tag color={config.color} className={`status-badge ${className}`}>
            {config.label}
        </Tag>
    );
};

StatusBadge.propTypes = {
    status: PropTypes.string,
    className: PropTypes.string,
};

export default StatusBadge;
